/**
 * Created by dushyantha on 10/10/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name trainingSchedule.controller:TrainingScheduleCtrl
     *
     * @description
     *
     */
    angular
        .module('trainingSchedule')
        .controller('TrainingScheduleCtrl', TrainingScheduleCtrl);

    function TrainingScheduleCtrl(CommonMasterData,MessageService,TrainingScheduleService,EventManagerService,TrainingProgramsService,$timeout,CrewingHelper,applicationConstants,CrewingAdaptor,RemoteService, $stateParams, StorageServices,PopupManager) {
        var vm = this;

        vm.model={
            showSearchArea:false,
            aircraftTypes:TrainingProgramsService.getDefaultAircraftType(),
            searchParam:{},
            trainingCategories:TrainingProgramsService.getDefaultTrainingCategory(),
            trainingSchedule:[],
            trainingOriginalSchedule:[],
            startPosition:1,
            defaultStartPosition:1,
            pageSize:2000,
            totalRecords:'',
            startIndex:0,
            isActiveProgramDetails:false,
            selectedRecord :[],
            selectedCrew: {},
            trainingPrograms:[],
            programDetails:[],
            assignedPrograms:[],
            trainerTypes:[],
            crewTypes:[],
            selectedTrainerCategory:[],
            refineParam:{
                startDate :"",
                toDate : "",
                aircraftModelDetails :TrainingScheduleService.getDefaultAircraftType(),
                trainingProCategoryDetails:TrainingScheduleService.getDefaultTrainingCategory(),
                selectedTrainingLocation:TrainingScheduleService.getDefaultTrainingLocation(),
                selectedProgramCode:TrainingScheduleService.getDefaultRefineTrainingProgramCodes(),
                selectedCrewType:TrainingScheduleService.getDefaultRefineCrewType(),
                selectedTrainer:TrainingScheduleService.getDefaultRefineTrainer(),
                selectedTrainee:TrainingScheduleService.getDefaultRefineTrainee()

            },
            doInitialSearch:false,
            isFilterActive:false,
            trainingLocation:TrainingScheduleService.getTrainingLocations(),
            activeTabIndex:0,
            crewSearchParams:[],
            keepSelectedTrainingInDetailsPanel: false,
            trainingCrewType:TrainingScheduleService.getDefaultTrainingCrewTypes(),
            trainingProgramCode:TrainingScheduleService.getDefaultTrainingProgramCodes(),
            trainingLocationList:TrainingScheduleService.getDefaultTrainingLocationList(),
            traineesList:TrainingScheduleService.getDefaultTraineesList(),
            trainersList:TrainingScheduleService.getDefaultTrainersList(),
            refineProgramCode:TrainingScheduleService.getRefineProgramCodes(),
            refineCrewType:TrainingScheduleService.getRefineCrewType(),
            refineTrainer:TrainingScheduleService.getRefineTrainers(),
            refineTrainee:TrainingScheduleService.getRefineTrainee()


        };

        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, elasticSearch);
        EventManagerService.registerEventListener(EventManagerService.EVENT.TRAINING_ASSIGN_CREW.ON_CLOSE_EXTERNAL_CREW_POPUP,updateDataSet);


        var tabLocalData = StorageServices.getTabData('trainingSchedule');
        if (!!tabLocalData && !!tabLocalData.trainingScheduleParams.startDate) {

            vm.model.searchParam.startDate = tabLocalData.trainingScheduleParams.startDate;
            vm.model.searchParam.endDate = tabLocalData.trainingScheduleParams.endDate;
            vm.model.searchParam.aircraftModel = null;
            vm.model.searchParam.trainingProCategory = null;
            vm.model.searchParam.pageSize = vm.model.pageSize;
            vm.model.searchParam.startPosition= vm.model.defaultStartPosition;
            vm.model.searchParam.programTypes = tabLocalData.trainingScheduleParams.programTypes;

            if(document.querySelector('#gridDataDiv') != null) {
                document.querySelector('#gridDataDiv').scrollTop = 0;
            }

            onSearchTrainingSchedule();

            StorageServices.setTabData('trainingSchedule', 'trainingScheduleParams', {
                startDate: null,
                endDate: null,
                programTypes : null
            });

         }

        vm.onSearchTrainingSchedule = function (searchParam) {
            vm.model.searchParam.startDate = searchParam.startDate || getStartDateOfMonth();
            var moEnd = moment( vm.model.searchParam.startDate , applicationConstants.SETTINGS.DATE_FORMAT).endOf('month');
            vm.model.searchParam.endDate = searchParam.endDate || moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
            vm.model.searchParam.aircraftModel = searchParam.aircraftModelDetails && $.trim(searchParam.aircraftModelDetails.model) || null;
            vm.model.searchParam.trainingProCategory= searchParam.trainingProCategoryDetails && searchParam.trainingProCategoryDetails.categoryCode || null ;
            vm.model.searchParam.pageSize= vm.model.pageSize;
            vm.model.searchParam.startPosition= vm.model.defaultStartPosition;//set the first start position

            vm.model.searchParam.trainingLocation = searchParam.trainingLocationDetails && $.trim(searchParam.trainingLocationDetails.locationCode) || null;
            vm.model.searchParam.programCode = searchParam.trainingProgramCodeDetails && $.trim(searchParam.trainingProgramCodeDetails.programCode) || null;
            vm.model.searchParam.crewType = searchParam.trainingCrewTypeDetails && $.trim(searchParam.trainingCrewTypeDetails.crewTypeCode) || null;
            vm.model.searchParam.trainer = searchParam.trainerDetails && $.trim(searchParam.trainerDetails.crewId) || null;
            vm.model.searchParam.trainee = searchParam.traineeDetails && $.trim(searchParam.traineeDetails.crewId) || null;

            if(document.querySelector('#gridDataDiv') != null) {
            	document.querySelector('#gridDataDiv').scrollTop = 0;
            }

            onSearchTrainingSchedule()
        };

        vm.changeSearchField = function(searchParam){
        	var acModel = null;
        	if(!!searchParam.aircraftModelDetails && searchParam.aircraftModelDetails !== " "){
        		acModel = _.find(vm.model.aircraftTypes, {
            		modelNumber : searchParam.aircraftModelDetails.model
                  });

        	} else {
        		acModel = _.find(vm.model.aircraftTypes, {
            		modelNumber : "ANY"
                  });
        	}
        	vm.model.refineParam.aircraftModelDetails = acModel;
        	var trainingCategory = null;
        	if(!!searchParam.trainingProCategoryDetails){
        		trainingCategory = _.find(vm.model.trainingCategories, {
        			categoryCode : searchParam.trainingProCategoryDetails.categoryCode
                  });
        	} else {
        		trainingCategory = _.find(vm.model.trainingCategories, {
        			category : "ANY"
                  });
        	}
        	vm.model.refineParam. trainingProCategoryDetails = trainingCategory;
        }

        function getStartDateOfMonth() {

          var date = new Date(), y = date.getFullYear(), m = date.getMonth();
          var firstDay = new Date(y, m, 1);
          var lastDay = new Date(y, m + 1, 0);
          firstDay = moment(firstDay).format('DD/MM/YYYY');
          lastDay = moment(lastDay).format('DD/MM/YYYY');
          return firstDay
        }


        function onSearchTrainingSchedule() {
            vm.model.doInitialSearch =true;
            TrainingScheduleService.searchTrainingSchedule(vm.model.searchParam,true,
                function (response) {
                    vm.model.showSearchArea = false;
                    vm.model.trainingSchedule = TrainingScheduleService.adaptTrainingData(response.scheduleDetails);
                    // console.log(response.scheduleDetails);
                    vm.model.trainingOriginalSchedule = angular.copy(vm.model.trainingSchedule);
                    TrainingScheduleService.setTrainingSchedule(vm.model.trainingSchedule);

                    if(vm.model.isFilterActive){
                        vm.model.trainingSchedule = TrainingScheduleService.refineTrainingData(vm.model.refineParam);
                    }
                    vm.model.trainingLocation=TrainingScheduleService.getTrainingLocations();
                    vm.model.refineProgramCode=TrainingScheduleService.getRefineProgramCodes();
                    vm.model.refineCrewType=TrainingScheduleService.getRefineCrewType();
                    vm.model.refineTrainer=TrainingScheduleService.getRefineTrainers();
                    vm.model.refineTrainee=TrainingScheduleService.getRefineTrainee();
                    if (!!vm.model.keepSelectedTrainingInDetailsPanel) {
                      vm.model.selectedRecord =  TrainingScheduleService.adaptSelectedTraining(vm.model.trainingSchedule[0]);
                    }
                    vm.model.startPosition = response.startPosition;
                    vm.model.totalRecords = response.totalRecords;
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }
        function onElasticSearchTrainingSchedule() {
            showHideElasticSearchLoading(true);
            TrainingScheduleService.searchTrainingSchedule(vm.model.searchParam,false,
                function (response) {
                    vm.model.showSearchArea = false;
                    TrainingScheduleService.appendToTrainingSchedule(vm.model.trainingSchedule ,response.scheduleDetails);
                    vm.model.trainingOriginalSchedule = angular.copy(vm.model.trainingSchedule);
                    TrainingScheduleService.setTrainingSchedule(vm.model.trainingSchedule);
                    vm.model.trainingLocation = TrainingScheduleService.getTrainingLocations();
                    if(vm.model.isFilterActive){
                        vm.model.trainingSchedule = TrainingScheduleService.refineTrainingData(vm.model.refineParam);
                    }
                    vm.model.trainingOriginalSchedule = angular.copy(vm.model.trainingSchedule);
                    vm.model.startPosition= response.startPosition;
                    vm.model.totalRecords = response.totalRecords;
                    showHideElasticSearchLoading(false)
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }
        function showHideElasticSearchLoading(flag) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                flag: flag,
                target: 'trainingSchedule',
                animationName: 'crewing-loader'
            });
        }
        function elasticSearch() {

            if (vm.model.trainingSchedule &&
                vm.model.totalRecords &&
                vm.model.searchParam.startPosition + vm.model.pageSize < vm.model.totalRecords
                ) {
                vm.model.searchParam.startPosition = vm.model.searchParam.startPosition + vm.model.pageSize;
                onElasticSearchTrainingSchedule();
            } else {
                var lastPageStartPos = vm.model.totalRecords - vm.model.pageSize;
                if (vm.model.startPosition < lastPageStartPos) {
                    vm.model.startPosition = lastPageStartPos;
                    onElasticSearchTrainingSchedule();
                }
            }


        }

        function getAirCraftTypes() {
          CommonMasterData.getAircraftModels(function (airCraftList) {
            vm.model.aircraftTypes = TrainingProgramsService.setAirCraftTypes(airCraftList);
          }, function (error) {});
        }

        function getTrainingCategories() {
            CommonMasterData.getTrainingCategories(
                function (response) {
                    TrainingScheduleService.setTrainingCategory(response);
                    vm.model.trainingCategories = TrainingScheduleService.getTrainingCategory();
                },
                function () {
                    console.log('Training categories retrieval error');
                }
            );
        }
        vm.loadTrainingCategory = function (selectedItem) {
            vm.model.trainingPrograms ='';
            vm.model.crewList='';
            vm.model.selectedRecord = selectedItem;
            if(vm.model.selectedRecord.trainingProgramId){
                vm.model.activeTabIndex= 1;
            }
            else{
                vm.model.activeTabIndex= 0;
            }
            getTrainingCategory();
        };

        function getTrainingCategory() {
            CommonMasterData.getTrainingProgram(vm.model.selectedRecord,
                function (programsResults) {
                    vm.model.trainingPrograms = TrainingScheduleService.adaptTrainingProgram(programsResults);
                    vm.model.isActiveProgramDetails = true;
                    vm.model.programDetails= '';
                    vm.model.assignedPrograms='';
                    if(!!vm.model.selectedRecord.trainingProgramId){
                        getTrainingProgram({trainingProgramId : vm.model.selectedRecord.trainingProgramId});
                        getTrainerTypes();
                        loadCrewTypes();
                    }
                },
                function (error) {
                    MessageService.error(MessageService.MESSAGES.COMMON.SYSTEM_ERROR);
                }
            )
        }
        vm.loadTrainingPrograms = function (category) {
            getTrainingProgram(category);

        };
        vm.onUpdateTrainingDetails = function (updateDTO) {

            TrainingScheduleService.updateTrainingProgram(updateDTO,function (updateResponse) {
                    if (updateResponse.success) {
                        MessageService.success(MessageService.MESSAGES.CREWING.UPDATE_SUCCESS);
                        //SlideInPanelService.toggle('crewing.right.panel', vm.blockDetails);

                        updateDataSet();
                    } else {
                        MessageService.error(MessageService.MESSAGES.CREWING.UPDATE_FAIL);
                    }
                },
                function (msg) {
                    MessageService.error(msg);
                });

        };
        vm.searchCrewList = function(searchDTO){
                vm.model.crewSearchParams = searchDTO;
                var param={};
                param.fromDate= searchDTO.fromDate || null;
                param.toDate= searchDTO.toDate || null;
                param.trainingProgramID= vm.model.selectedRecord.trainingProgramId || null;
                param.days= searchDTO.days || null;
                param.crewId= searchDTO.crewId || null;
                param.trainerType=searchDTO.trainerType && searchDTO.trainerType.trainerTypeCode || null;
                param.crewTypeCode=searchDTO.crewType && searchDTO.crewType.crewTypeCode || null;
                param.slotId= vm.model.selectedRecord.trainingSlotId || null;


            TrainingScheduleService.searchCrewList(param,function (response) {
                    if(searchDTO.excludePlannedCrew){
                      var res=[];
                      response.filter(function(crew){
                        if(!crew.plannedDate){
                          res.push(crew);
                        }
                      })
                      vm.model.crewList=res;
                    }else{
                       vm.model.crewList=response;
                    }
                },
                function (msg) {
                MessageService.error(msg);
                });
        };
        vm.assignTrainerTrainee = function(param){
          var flags = {
            isContinueIllegal: true,
            isUserConfirm: false,
            isExpiryUpdatable: false,
            isIgnoreConflicts: false,
            isIgnoreExpiries: false
          };

          var onAssignSuccess = function () {
           // EventManagerService.notifyEventListeners(EventManagerService.EVENT.TOOLBAR.REFRESH);
            updateDataSet();
            CommonMasterData.getTrainingProgram(vm.model.selectedRecord,
              function (programsResults) {
                var index = vm.model.crewList.indexOf(vm.model.selectedCrew);
                vm.model.crewList.splice(index, 1);

              },
              function (error) {
                MessageService.error(MessageService.MESSAGES.COMMON.SYSTEM_ERROR);
              }
            );
          };

          var onCancel = function () {
            param.isAssigned = false;
          };

          var doAssign = function (params, flag) {
            params.continueIllegal = !!flags.isContinueIllegal;
            params.userConfirm = !!flags.isUserConfirm;
            params.expiryUpdatable = !!flags.isExpiryUpdatable;
            params.ignoreConflicts = !!flags.isIgnoreConflicts;
            params.ignoreExpiries = !!flags.isIgnoreExpiries;

            RemoteService.assignTrainerTrainee(params,true).then(
              function (response) {
                var adapted = CrewingAdaptor.assignTrainingAdaptor(response);
                CrewingHelper.assignTrainingActionList(params, adapted, flag, doAssign, onAssignSuccess, onCancel);
              },
              function (error) {
                MessageService.error(error);
              }
            );
          };

          doAssign(param, flags);



        };
        vm.removeCrewFromProgram = function(removeDTO){

        	if(!removeDTO.assignedCrew.externalCrew){
            var param={};
            param.unAssignColl=[];
            param.unAssignColl.push({
                "crewProfileId" :removeDTO.assignedCrew.profileId,
                "crewSchdBlockId":removeDTO.assignedCrew.crewSchdBlockId
            }) ;

            TrainingScheduleService.unAssignTrainerTrainee(param,
                function () {
                    updateDataSetAfterRemoval(removeDTO.assignedCrew);
                    searchCrewList();
                    MessageService.success(MessageService.MESSAGES.TRAINING_SCHEDULE.TRAINER_REMOVE_SUCCESS);
                },
                function () {
                    MessageService.error(MessageService.MESSAGES.TRAINING_SCHEDULE.TRAINER_REMOVE_FAILED);
                }
            );
        	}else{

        		removeExternalCrew(removeDTO);
        	}
        };
        function searchCrewList(){
          if(vm.model.crewSearchParams.length > 0){
            vm.searchCrewList(vm.model.crewSearchParams);
          }
        }

        function removeExternalCrew(removeDTO){

        	var param={};
            param.externalTraineeId = removeDTO.assignedCrew.externalTraineeId;
            TrainingScheduleService.unAssignExternalTrainee(param,
                function () {
                    updateDataSet();
                    MessageService.success(MessageService.MESSAGES.TRAINING_SCHEDULE.TRAINER_REMOVE_SUCCESS);
                },
                function () {
                    MessageService.error(MessageService.MESSAGES.TRAINING_SCHEDULE.TRAINER_REMOVE_FAILED);
                }
            );

        }

        function getTrainingProgram(category) {
            vm.model.programDetails='';
            CommonMasterData.getTrainingProgramDetails(category,
                function (programDetailsResults) {
                    vm.model.assignedPrograms = TrainingScheduleService.getAssignedList(programDetailsResults ,vm.model.selectedRecord);
                    vm.model.programDetails = TrainingScheduleService.adaptProgramList(vm.model.assignedPrograms,programDetailsResults);
                },
                function (error) {
                    MessageService.error(MessageService.MESSAGES.COMMON.SYSTEM_ERROR);
                }
            );

        }
        function getTrainerTypes(){
             TrainingScheduleService.getTrainerTypes(
                function (response) {
                    vm.model.trainerTypes = response;
                },
                function (msg) {
                    MessageService.error(msg);
                })
        }
        function loadCrewTypes() {
            CommonMasterData.getCrewTypeList(
                function (crewTypes) {
                    vm.model.crewTypes = crewTypes;
                },
                function () {
                    console.log('Crew type retrieval error');
                }
            );
        }
        function loadTrainingBySlotID(){
            var param={};
            param.trainingSlotId = vm.model.selectedRecord.trainingSlotId;

             TrainingScheduleService.getTrainingBySlotID(param,
                function (response) {
                    vm.model.selectedRecord = response;
                    if(vm.model.selectedRecord.trainingProgramId){
                        vm.model.activeTabIndex= 1;
                    }
                    else{
                        vm.model.activeTabIndex= 0;
                    }

                },
                function () {

                }
            );
        }
        vm.changeCriteria = function () {
        	vm.model.isFilterActive = true;
            if(vm.model.doInitialSearch){
                vm.model.trainingSchedule = TrainingScheduleService.refineTrainingData(vm.model.refineParam);
            }
        };
        vm.addCrewToProgram= function(){
            getTrainingCategory()
        };
        vm.deleteTraining =function(){

          angular.forEach(vm.model.trainingSchedule, function (schedule) {
            if(schedule.isSelected){
              vm.model.selectedRecord = schedule;
            }
          });

          var param={"deleteTrainingSlotList":[{"trainingSlotId":vm.model.selectedRecord.trainingSlotId,"version":vm.model.selectedRecord.trainingSlotVersion}]}

            TrainingProgramsService.deleteTrainingPrograms(param,
                function (response) {
                    if(response.success){
                        MessageService.success('Successfully deleted');

                      for (var key in response.otherHubSyncResponses) {
                        if (response.otherHubSyncResponses.hasOwnProperty(key)) {
                          if (response.otherHubSyncResponses[key]) {
                            MessageService.success('Tenant: ' + key + ', Status: SUCCESS');
                          } else {
                            MessageService.warning('Tenant: ' + key + ', Status: FAILED');
                          }
                        }
                      }

                        onSearchTrainingSchedule();

                        /*with out reloading data*/
                        /*var index =  vm.model.trainingSchedule.map(function(el) {
                            return el.trainingSlotId;
                        }).indexOf(vm.model.selectedRecord.trainingSlotId);
                        if (index > -1) {
                            vm.model.trainingSchedule.splice(index, 1);
                        }
                        vm.model.selectedRecord='';*/
                    }else{
                        MessageService.error(response.errors[0]);
                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };
        function updateDataSet() {
            loadTrainingBySlotID();
            getTrainingCategory();
        }

      function updateDataSetAfterRemoval() {
        loadTrainingBySlotID();
        getTrainingCategory();
        vm.model.keepSelectedTrainingInDetailsPanel = true;
        onSearchTrainingSchedule();
        vm.model.keepSelectedTrainingInDetailsPanel = false;
      }

        vm.onRefresh = function () {
          onSearchTrainingSchedule();
        }


      function getTrainingCrewType() {
          CommonMasterData.getCrewTypeList(function (response) {
          TrainingScheduleService.setTrainingCrewTypes(response);
          vm.model.trainingCrewType=TrainingScheduleService.getTrainingCrewTypes();
          },function () {
            console.log('Training Crew Types retrieval error');
          })
      }

      function getTrainingProgramCodes() {
        CommonMasterData.getProgramCodeList(function (response) {
          TrainingScheduleService.setTrainingProgramCodes(response);
          vm.model.trainingProgramCode=TrainingScheduleService.getTrainingProgramCodes();
        },function () {
          console.log('Training Program codes retrieval error');
        })
      }

      function getTrainingLocationList() {
        CommonMasterData.getTrainingLocationList(function (response) {
          TrainingScheduleService.setTrainingLocationList(response);
          vm.model.trainingLocationList=TrainingScheduleService.getTrainingLocationList();
        },function () {
          console.log('Training Location retrieval error');
        })
      }

      function getTraineesList() {
        CommonMasterData.getTraineeList(function (response) {
          TrainingScheduleService.setTraineesList(response);
          vm.model.traineesList=TrainingScheduleService.getTraineesList();
        },function () {
          console.log('Trainees retrieval error');
        })
      }

      function getTrainersList() {
        CommonMasterData.getTrainerList(function (response) {
          TrainingScheduleService.setTrainersList(response);
          vm.model.trainersList=TrainingScheduleService.getTrainersList();
        },function () {
          console.log('Trainers retrieval error');
        })
      }



        function init() {
            getAirCraftTypes();
            getTrainingCategories();
            loadCrewTypes();
            getTrainerTypes();
            getTrainingCrewType();
            getTrainingProgramCodes();
            getTrainingLocationList()
            getTraineesList();
            getTrainersList();
        }
        init();


    }
}());


